import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.52892 2.86195C7.78927 2.6016 8.21138 2.6016 8.47173 2.86195L13.1384 7.52862C13.3987 7.78896 13.3987 8.21108 13.1384 8.47142L8.47173 13.1381C8.21138 13.3984 7.78927 13.3984 7.52892 13.1381C7.26857 12.8777 7.26857 12.4556 7.52892 12.1953L11.0575 8.66669H3.33366C2.96547 8.66669 2.66699 8.36821 2.66699 8.00002C2.66699 7.63183 2.96547 7.33335 3.33366 7.33335H11.0575L7.52892 3.80476C7.26857 3.54441 7.26857 3.1223 7.52892 2.86195Z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
